import type { BaseError as ViemBaseError } from "viem"
import { InsufficientFundsError as EvmInsufficientFundsError } from "viem"
import type { BaseError as WagmiBaseError } from "wagmi"

type MetaMaskInsufficientFundsError = {
  data: {
    message?: string
  }
}

/**
 * Using custom method for detecting since viem does not catch this for all wallets
 */
export function isInsufficientFundsError(
  error: WagmiBaseError | ViemBaseError,
): boolean {
  return !!error.walk(e => {
    if (e instanceof EvmInsufficientFundsError) {
      return true // Viem has detected this as an insufficient funds error
    }

    // Check if this is a MetaMask insufficient funds error (uncaught by viem)
    const maybeMetaMaskError = e as Partial<MetaMaskInsufficientFundsError>
    if (
      maybeMetaMaskError.data?.message?.match(
        EvmInsufficientFundsError.nodeMessage,
      )
    ) {
      return true
    }

    const errorMessage = e instanceof Error ? e.message : JSON.stringify(e)

    if (INSUFFICIENT_FUNDS_REGEX.test(errorMessage)) {
      return true
    }

    return false
  })
}

export const INSUFFICIENT_FUNDS_REGEX =
  /(Insufficient (funds|balance|ETH))|ETH not enough/i
